/* eslint-disable */

import { TimelineMax, TweenMax } from '@/vendor';
import Config from '@/app/game/data/config.json';
import GameObj from '@/app/game/elements/GameObj';

export default class Ball extends GameObj
{
    constructor( settings )
    {
        super( settings );
        this.settings = Object.assign({}, settings );
        this.id = settings.id;

        this.z = settings.z;
        this.pos.x = settings.x + settings.ballSize / 2;
        this.pos.y = settings.y + settings.ballSize / 2;

        let texture = PIXI.loader.resources[ 'ball' + Math.floor( Math.random() * 44 + 1 ) ].texture;
        this.sprite = new PIXI.Sprite( texture );

        this.sprite.anchor.set( 0.5 );

        this.sprite.width = this.sprite.height = settings.ballSize;

        this.sprite.x = this.pos.x;
        this.sprite.y = this.pos.y;
        this.sprite.cacheAsBitmap = true;
        this.sprite.hitArea = new PIXI.Circle( 0, 0, 38 );

        this.testGraphic = new PIXI.Graphics();
        this.testGraphic.beginFill( 0x000000 );

        this.testGraphic.drawCircle( 0, 0, 38 );

        this.testGraphic.alpha = 1 - settings.brightness;

        this.sprite.addChild( this.testGraphic );

        this.sprite.interactive = true;

        this.sprite.on( 'pointerdown', this.onClick.bind( this ) );
        this.sprite.on( 'tap', this.onClick.bind( this ) );

        this.sprite.zIndex = settings.z;
    }

    onClick( e )
    {
        this.eventHub.emit( 'ballSuicide' + this.id, this );
    }

    updateBrightness( pInstantly )
    {
        // needs check
        this.sprite.cacheAsBitmap = false;

        let layer = this.z;

        let brightness = Config.BRIGHTNESS_MIN + ( Config.BRIGHTNESS_MAX - Config.BRIGHTNESS_MIN ) / (Config.BALL_LAYERS - 1) * layer;
        let nextBrightness = Config.BRIGHTNESS_MIN + ( Config.BRIGHTNESS_MAX - Config.BRIGHTNESS_MIN ) / (Config.BALL_LAYERS - 1) * ( layer + 1 );

        if( !pInstantly )
        {
            // this.colorTween = TweenMax.to( this.testGraphic, 1, { alpha: 1 - nextBrightness, onComplete: () => { this.z++; this.sprite.cacheAsBitmap = true; } });
        }
        else
        {
            // this.testGraphic.alpha = 1 - nextBrightness;
            this.z ++;
            this.sprite.cacheAsBitmap = true;
        }
    }

    beforeDestroy()
    {
        return new Promise( resolve =>
        {
            let tl = new TimelineMax({ onComplete: resolve });
            tl.to( this.sprite, 0.3, { width: 0, height: 0, alpha: 0 }, 0 );
        });
    }

    fancyDeathAnim()
    {
        return new Promise( resolve =>
        {
            let tl = new TimelineMax({ onComplete: resolve });
            tl.to( this.sprite, 0.2, { alpha: 0, width: '+=10', height: '+=10', y: '-=10' }, 0 );
        });
    }

    async destroy()
    {
        this.sprite.interactive = false;
        await this.beforeDestroy();
        this.sprite.parent.removeChild( this.sprite );
    }

    async fancyRemove()
    {
        this.sprite.interactive = false;
        await this.fancyDeathAnim();
        // this.sprite.parent.removeChild( this.sprite );
    }
}



// WEBPACK FOOTER //
// ./src/app/game/elements/Ball.js